<template>
	<div>
		<Header @getHeaderHeight="getHeaderHeight"></Header>
		<div class="page" :style="{ 'padding-top': headerHeight - 1 + 'px' }">
			<div class="page-header">
				<div class="page-header-container">
					<div class="page-header-inner">
						<div class="fx">
							<div class="page-header-left">
								<div class="hello">{{ $t('about.headHL') }}</div>
								<div class="txt">{{ $t('about.headSub') }}</div>
							</div>
							<div class="page-header-right">
								<LazyImage :imagePath="imagePath"></LazyImage>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="content">
				<div class="inner">
					<div class="concept">
						<div class="concept-item">
							<div class="title">{{ $t('about.outTitle2') }}</div>
							<div class="intro">
								<p>{{ $t('about.outIntro1') }}</p>
							</div>
						</div>
						<div class="concept-item pt8">
							<div class="title">{{ $t('about.outTitle2') }}</div>
							<div class="intro">
								<p>{{ $t('about.outIntro2') }}</p>
							</div>
						</div>
						<div class="concept-item pt8">
							<div class="title">{{ $t('about.outTitle3') }}</div>
							<div class="intro">
								<p>{{ $t('about.outIntro3') }}</p>
							</div>
						</div>
					</div>
					<div class="contact">
						<div class="contact-inner">
							<div class="titleWrap">
								<div class="headline">{{ $t('about.contactHL') }}</div>
								<div class="subtitle">{{ $t('about.contactSub') }}</div>
							</div>
							<div class="imgWrap">
								<img src="@/static/img/icon-about-contact.png" alt="">
							</div>
						</div>
						<div class="investor pt8">
							<div class="title">{{ $t('about.outTitle4') }}</div>
							<div class="intro">
								<span>{{ $t('about.outIntro4Part1') }}</span>
								<span class="link">AuroraMcplayer@yandex.ru</span>
								<span>{{ $t('about.outIntro4Part2') }}</span>
							</div>
						</div>
						<div class="customers pt8">
							<div class="title">{{ $t('about.outTitle5') }}</div>
							<div class="intro">
								<span>{{ $t('about.outIntro5Part1') }}</span>
								<span class="link">{{ $t('about.outIntro5Part2') }}</span>
								<span>{{ $t('about.outIntro5Part3') }}</span>
							</div>
						</div>
						<div class="contact-information pt8">
							<div class="title">MAX & Telegtam & WhatsApp</div>
							<div class="information-wrap">
								<div class="information-item">
									<div class="scan">
										<img src="@/static/img/max-about-img.png" alt="">
									</div>
									<div class="number">+7 916 166 62 80</div>
								</div>
								<div class="information-item">
									<div class="scan">
										<img src="@/static/img/telegram-about-img.png" alt="">
									</div>
									<div class="number">+7 931 158 8108</div>
								</div>
								<div class="information-item">
									<div class="scan">
										<img src="@/static/img/whatsapp-about-img.png" alt="">
									</div>
									<div class="number">@AURORAMCPLAYER</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>

</template>

<script>
	import Header from '../header/index.vue'
	import Footer from '../footer/index.vue'
	export default {
		name: 'TVAbout',
		components: {
			Header,
			Footer
		},
		data() {
			return {
				headerHeight: '',
				imagePath: require('@/static/img/icon-about-img.png')
			};
		},
		computed: {},
		methods: {
			getHeaderHeight(val) {
				this.headerHeight = val
			}
		},
		created() {

		},
		mounted() {

		},
		updated() {},
	}
</script>
<style lang='less' scoped>
	.page-header-container {
		border-radius: 0 !important;
	}

	.page-header-inner {
		padding-top: 21px;
	}

	.hello {
		font-size: 40px;
		color: #2AF1A8;
		font-family: 'Alibaba PuHuiTi B';
	}

	.txt {
		font-size: 48px;
		color: #FFF;
		font-family: 'Alibaba PuHuiTi B';
	}

	.content {
		padding: 0 24px;

		.inner {
			max-width: 1280px;
			margin: 0 auto;
			padding: 64px 0 80px;

			.pt8 {
				padding-top: 80px;
			}
		}

		.title {
			color: #151515;
			font-size: 24px;
			font-family: 'Alibaba PuHuiTi B';
			padding-bottom: 16px;
		}
		
		.intro {
			font-size: 16px;
			color: #7C7C7C;
		}

		.link{
			cursor: pointer;
			color: #7bb0ff;
		}
		
		.contact-inner {
			position: relative;
			background: linear-gradient(0deg, #1D4346 0%, #3D7961 100%);
			border-radius: 20px;
			padding: 0 56px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			min-height: 230px;
			margin-top: 134px;

			.headline {
				word-break: break-all;
				color: #fff;
				font-size: 48px;
				font-family: 'Alibaba PuHuiTi B';
			}

			.subtitle {
				color: #fff;
				font-size: 32px;
				font-family: 'Alibaba PuHuiTi R';
			}

			.imgWrap {
				position: absolute;
				right: 0;
				bottom: 0;

				img {
					width: 100%;
					height: 100%;
					display: block;
				}
			}
		}

		.information-wrap {
			display: flex;
			gap: 64px;
		}
	}

	@media (max-width: 768px) {
		.information-wrap {
			flex-wrap: wrap;
		}
		.hello {
			padding-top: 24px;
		}

		.contact-inner {
			flex-direction: column;
			padding: 0 !important;
			margin-top: 80px !important;
		}

		.titleWrap {
			width: 100%;
			text-align: left;
			padding: 16px;
		}

		.imgWrap {
			position: static !important;
		}
	}
</style>